import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('@/views/Products.vue')
  },
  {
    // 分类商品列表：地址按分类名称命名（空格 → -），如 /products/category/Home-Living
    path: '/products/category/:slug',
    name: 'ProductsCategory',
    component: () => import('@/views/Products.vue')
  },
  {
    // SEO 友好 URL：/products/{标题-slug}-{id}.html
    path: '/products/:slug(.*)-:id(\\d+).html',
    name: 'ProductDetail',
    component: () => import('@/views/ProductDetail.vue')
  },
  {
    // 兼容旧链接：/products/{id}（加载后自动跳转到带 slug 的规范 URL）
    path: '/products/:id(\\d+)',
    name: 'ProductDetailLegacy',
    component: () => import('@/views/ProductDetail.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('@/views/News.vue')
  },
  {
    // SEO 友好 URL：/news/{标题-slug}-{id}.html
    path: '/news/:slug(.*)-:id(\\d+).html',
    name: 'NewsDetail',
    component: () => import('@/views/NewsDetail.vue')
  },
  {
    // 兼容旧链接：/news/{id}
    path: '/news/:id(\\d+)',
    name: 'NewsDetailLegacy',
    component: () => import('@/views/NewsDetail.vue')
  },
  {
    path: '/member/login',
    name: 'MemberLogin',
    component: () => import('@/views/member/MemberLogin.vue')
  },
  {
    path: '/member/register',
    name: 'MemberRegister',
    component: () => import('@/views/member/MemberRegister.vue')
  },
  {
    path: '/member/account',
    name: 'MemberAccount',
    component: () => import('@/views/member/MemberAccount.vue'),
    meta: { requiresMember: true }
  },
  {
    path: '/member/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/member/ForgotPassword.vue')
  },
  {
    path: '/member/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/member/ResetPassword.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue')
  },
  {
    // 静态页面（后台可编辑内容）：/shipping-returns /size-guide /faq /privacy-policy /terms-of-service
    path: '/pages/:slug',
    name: 'PageContent',
    component: () => import('@/views/PageContent.vue')
  },
  {
    // 简写路径（无 /pages 前缀，供底部链接直接使用）
    path: '/shipping-returns',
    redirect: '/pages/shipping-returns'
  },
  {
    path: '/size-guide',
    redirect: '/pages/size-guide'
  },
  {
    path: '/faq',
    redirect: '/pages/faq'
  },
  {
    path: '/privacy-policy',
    redirect: '/pages/privacy-policy'
  },
  {
    path: '/terms-of-service',
    redirect: '/pages/terms-of-service'
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import('@/views/Cart.vue')
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: () => import('@/views/Checkout.vue')
  },
  {
    path: '/order/:orderNo',
    name: 'OrderSuccess',
    component: () => import('@/views/OrderSuccess.vue')
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/views/admin/AdminLogin.vue')
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: () => import('@/views/admin/AdminDashboard.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('admin_token')
    if (!token) {
      next('/admin')
    } else {
      next()
    }
  } else if (to.meta.requiresMember) {
    const token = localStorage.getItem('member_token')
    if (!token) {
      next('/member/login')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
